import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";

const ACCEPT = "image/png,image/jpeg,image/webp";
const ALLOWED = ["image/png", "image/jpeg", "image/webp"];

export function ImageDropzone({ multiple = false, onFiles, label, hint, testid = "image-dropzone", compact = false }) {
  const inputRef = useRef(null);
  const [over, setOver] = useState(false);

  const handle = (fileList) => {
    const files = Array.from(fileList || []).filter((f) => ALLOWED.includes(f.type));
    if (files.length) onFiles(multiple ? files : [files[0]]);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      data-testid={testid}
      onClick={() => inputRef.current?.click()}
      onKeyDown={(e) => (e.key === "Enter" || e.key === " ") && inputRef.current?.click()}
      onDragOver={(e) => {
        e.preventDefault();
        setOver(true);
      }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setOver(false);
        handle(e.dataTransfer.files);
      }}
      className={`group flex cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed text-center transition-[border-color,background-color] duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-400 ${
        compact ? "px-4 py-6" : "px-6 py-14"
      } ${over ? "border-amber-400 bg-amber-500/10" : "border-amber-900/50 bg-[#121620]/70 hover:border-amber-600/70"}`}
    >
      <UploadCloud className="mb-3 h-8 w-8 text-amber-500/80 transition-transform duration-300 group-hover:-translate-y-1" aria-hidden />
      <p className="font-heading text-base text-amber-100">{label || (multiple ? "Drop card images here" : "Drop an image here")}</p>
      <p className="mt-1 text-xs text-slate-400">{hint || "PNG, JPG or WebP · up to 15 MB each · or click to browse"}</p>
      <input
        ref={inputRef}
        type="file"
        accept={ACCEPT}
        multiple={multiple}
        className="hidden"
        data-testid={`${testid}-input`}
        onChange={(e) => {
          handle(e.target.files);
          e.target.value = "";
        }}
      />
    </div>
  );
}
